// /Users/donovan68/dva-frontend-vite/src/components/journey/pro/ProJourneyPageHeader.tsx
// Compact page header for Pro Journey steps
// Badge + Stacked Text: "[Step X] Step Name" on line 1, description on line 2

import React from 'react';

interface ProJourneyPageHeaderProps {
  /** Step number (1-3) */
  stepNumber: number;
  /** Step name (e.g., "Portfolio Exploration", "Analysis & Qualification") */
  stepName: string;
  /** Description text - concise one-liner */
  description: string;
  /** Optional action buttons/content aligned to the right */
  actions?: React.ReactNode;
  /** Optional additional content below description */
  supplemental?: React.ReactNode;
}

const ProJourneyPageHeader: React.FC<ProJourneyPageHeaderProps> = ({
  stepNumber,
  stepName,
  description,
  actions,
  supplemental,
}) => {
  return (
    <header className="flex flex-col gap-2">
      {/* Top row: Step badge + Title, with optional actions */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          {/* Step Badge */}
          <span 
            className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold bg-[#18365E]/10 text-[#18365E]"
            style={{ fontWeight: 600 }}
          >
            Step {stepNumber}
          </span>
          
          {/* Step Name/Title */}
          <h2 className="text-lg font-semibold text-[#18365E]">
            {stepName}
          </h2>
        </div>
        
        {/* Optional actions - right aligned */}
        {actions && (
          <div className="flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
      
      {/* Description text */}
      <p className="text-sm text-[#717182] leading-relaxed">
        {description}
      </p>
      
      {/* Optional supplemental content below description */}
      {supplemental && (
        <div className="mt-1">
          {supplemental}
        </div>
      )}
    </header>
  );
};

export default ProJourneyPageHeader;